import React from "react";
import { connect } from "react-redux";
import {closeCollectionAddModel} from '../actions'
import mainHelper, {apiCall} from "../helpers/MainHelper";
import ReactLoading from "react-loading";
class AddCollectionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      banks: [],
      amount: '',
      collection_date: '',
      payment_type: '',
      description: '',
      receiveID: '',
      bank_id: '',
      loading:false,
    };
  }
  async componentDidMount() {
    try {
      this.getBanks();
    }catch (e) {
      console.error(e)
    }

  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  getBanks = async () => {
    try {
        const response = await apiCall('business/settings/bank-account-list', 'get', null);

        this.setState({ banks: response });
    } catch (e) {
      console.error("API çağrısında bir hata oluştu:", e);
    }
  };

  handleAddCollection = async (event) => {
    event.preventDefault();
    this.setState({loading:true})
    const { addCollectionReceiveID } = this.props;

    const { amount,collection_date,payment_type,description,bank_id } = this.state;

    try {
      const response = await apiCall('business/receivable/collection/add/'+addCollectionReceiveID,'post',
          { amount:amount, collection_date:collection_date,payment_type:payment_type,description:description,bank_id:bank_id });

      await this.props.fetchReceive();
      mainHelper.toastMessage(response.status,response.message);
      this.setState({loading:false})
    }catch (e) {
      this.setState({loading:false})
    }

  };
  render() {
    const { isAddCollectionModalOpen } = this.props;
    const { loading,banks} = this.state;
    return (
        <div className={isAddCollectionModalOpen ? "modal fade show" : "modal fade"}
            role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="title" id="defaultModalLabel">
                  Ödeme veya Tahsilat ekle
                </h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="amount"
                        id="amount"
                        type="number"
                        className="form-control"
                        placeholder="Tahsilat/Ödeme Tutarı Giriniz"
                        value={this.state.amount}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <select
                        name="payment_type"
                        id="payment_type"
                        className="form-control"
                        value={this.state.payment_type}
                        onChange={this.handleInputChange}>
                      <option value="">Ödeme Tipi Seçiniz</option>
                      <option value="Nakit">Nakit</option>
                      <option value="Kredi Kartı">Kredi Kartı</option>
                      <option value="Havale/EFT">Havale/EFT</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="collection_date"
                        id="collection_date"
                        type="date"
                        className="form-control"
                        value={this.state.collection_date}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <select name="bank_id" id='bank_id' className="form-control"
                          onChange={this.handleInputChange}>
                    <option value="">Banka Seçiniz</option>
                    {banks && (banks.map(bank => (
                        <option key={bank.id} value={bank.id}>{bank.name}</option>
                    )))}

                  </select>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <textarea
                        name="description"
                        id="description"
                        placeholder="Açıklama"
                        className="form-control"
                        value={this.state.description}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">

                {loading ? (
                    <button className="btn btn-outline-primary btn-lg" disabled={true}
                            style={{textAlign: "-webkit-center"}}>
                      Lütfen Bekleyin...
                      <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"/>
                    </button>
                ) : (
                    <button type="button" className="btn btn-outline-primary" onClick={this.handleAddCollection}>
                      Ekle
                    </button>
                )}
                <button
                    type="button"
                    onClick={this.props.closeCollectionAddModel}
                    className="btn btn-simple"
                    data-dismiss="modal"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>

        </div>
    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({
  isAddCollectionModalOpen: mailInboxReducer.isAddCollectionModalOpen,
  addCollectionReceiveID: mailInboxReducer.addCollectionReceiveID,
});

export default connect(mapStateToProps, {closeCollectionAddModel})(AddCollectionModal);
